module.exports = __webpack_public_path__ + "img/candle-1.6cfb4e30.png";